import React from 'react';

export default function DataAnalysisIcon() {
	return (
		<svg width="100%" height="100%" viewBox="0 0 41 41" fill="none" xmlns="http://www.w3.org/2000/svg">
			<mask id="mask0_1077_14791" style={{ maskType: 'alpha' }} maskUnits="userSpaceOnUse" x="0" y="0" width="41" height="41">
				<rect x="0.832031" y="0.819702" width="40" height="40" fill="#2D3846" />
			</mask>
			<g mask="url(#mask0_1077_14791)">
				<path d="M5.83203 34.153V12.4864L12.4987 17.4864L20.832 5.8197L29.1654 12.4864H35.832V34.153H5.83203ZM14.1654 29.153L20.832 19.9864L32.4987 29.0697V15.8197H27.9987L21.4987 10.6114L13.2487 22.1947L9.16536 19.153V25.153L14.1654 29.153Z" fill="#2D3846" />
			</g>
		</svg>
	);
}
